module.exports = __webpack_public_path__ + "img/concrete-hole-decal-04.5fd96c32.png";